'use es6';

import http from 'hub-http/clients/apiClient';
import { Map as ImmutableMap, List, Range, Seq } from 'immutable';
import { Reference, ReferenceSources } from '../references-records';
import { getDefaultDisplayLabel, isIdProperty, OVERRIDES } from './object-mapping';
import { withCheckbox } from '../checkbox';
import { Metrics } from '../../../../shared/Metrics';
const chunk = (collection, size) => Range(0, collection.count(), size).map(start => collection.slice(start, start + size));
const defaultGetFallbackReference = id => Reference({
  id,
  label: id,
  source: ReferenceSources.OBJECT
});
export const getObjectResolver = (snowflakeTable, snowflakeProperty) => {
  const {
    objectTypeId,
    metaDefinition: {
      primaryDisplayLabelPropertyName,
      secondaryDisplayLabelPropertyNames
    } = {}
  } = snowflakeTable;
  const {
    name
  } = snowflakeProperty;
  if (!isIdProperty(name, objectTypeId) || primaryDisplayLabelPropertyName == null) {
    return undefined;
  }
  const getDisplayLabel = OVERRIDES.get(objectTypeId) || getDefaultDisplayLabel;
  const toReference = (id, objectPreview, getFallbackReference) => {
    if (!objectPreview) {
      Metrics.counter('no_resolver', {
        type: 'object'
      }).increment();
      return getFallbackReference(id);
    }
    const properties = Seq(objectPreview.properties || {}).map(property => property.value).toObject();
    const label = getDisplayLabel(id, primaryDisplayLabelPropertyName, secondaryDisplayLabelPropertyNames, properties);
    return Reference({
      id,
      label,
      source: ReferenceSources.OBJECT
    });
  };
  const baseResolver = (ids, getFallbackReference) => {
    const chunks = chunk(List(ids), 200);
    const promises = chunks.map(chunkIds => http.post('inbounddb-objects/v1/preview', {
      data: {
        [objectTypeId]: chunkIds
      }
    }).then(response => {
      const objectPreviews = response[objectTypeId] || {};
      return chunkIds.map(id => [id, toReference(id, objectPreviews[id], getFallbackReference)]);
    }).catch(e => {
      Metrics.counter('no_resolver', {
        type: 'object'
      }).increment();
      throw e;
    }));
    return Promise.all(promises).then(resChunks => ImmutableMap(List(resChunks).flatten(1)));
  };
  return (ids, getFallbackReference = defaultGetFallbackReference) => {
    const resolver = withCheckbox(snowflakeProperty)(baseResolver);
    return resolver(ids, getFallbackReference);
  };
};